import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      padding: theme.spacing(2),
      bottom: "4px",
      left: "4px",
    },
  },
}));

const Navigation = ({ onBackClick }) => {
  const classes = useStyles();
  return (
    <Button
      variant="text"
      color="secondary"
      onClick={onBackClick}
      className={classes.root}
    >
      Zurück
    </Button>
  );
};

export default Navigation;
